export interface ListenerTier {
  id: number;
  name: string;
  slug: string;
  level: number;
  icon: string;
  color: string;
  bgColor: string;
  textColor: string;
  borderColor: string;
  badgeBg: string;
  badgeText: string;
  description: string;
  minHours: number;
  minComments: number;
  minParticipations: number;
  benefits: string[];
}

export interface ListenerProfile {
  id: number;
  name: string;
  photoUrl: string;
  username: string;
  tierId: number;
  tierName: string;
  tierLevel: number;
  hoursListened: number;
  comments: number;
  participations: number;
  greetings: number;
  requests: number;
  joinedDate: string;
  mainRadio: string;
  mainRadioFrequency: string;
  progressToNext: number;
  nextTierName: string;
}

export const listenerTiers: ListenerTier[] = [
  {
    id: 1,
    name: 'Nuevo',
    slug: 'nuevo',
    level: 1,
    icon: 'ri-user-line',
    color: 'stone',
    bgColor: 'bg-stone-50',
    textColor: 'text-stone-700',
    borderColor: 'border-stone-200',
    badgeBg: 'bg-stone-200',
    badgeText: 'text-stone-600',
    description: 'Oyente recién llegado al ecosistema RFW. Está descubriendo radios y programas.',
    minHours: 0,
    minComments: 0,
    minParticipations: 0,
    benefits: ['Acceso a radios públicas', 'Chat en vivo (solo lectura)', '1 dispositivo'],
  },
  {
    id: 2,
    name: 'Activo',
    slug: 'activo',
    level: 2,
    icon: 'ri-user-smile-line',
    color: 'emerald',
    bgColor: 'bg-emerald-50',
    textColor: 'text-emerald-700',
    borderColor: 'border-emerald-200',
    badgeBg: 'bg-emerald-200',
    badgeText: 'text-emerald-700',
    description: 'Oyente frecuente que ya tiene sus radios y programas favoritos. Participa activamente.',
    minHours: 50,
    minComments: 10,
    minParticipations: 5,
    benefits: ['Chat en vivo completo', 'Seguir 3 programas', 'Notificaciones push', '2 dispositivos'],
  },
  {
    id: 3,
    name: 'Fan',
    slug: 'fan',
    level: 3,
    icon: 'ri-user-heart-line',
    color: 'amber',
    bgColor: 'bg-amber-50',
    textColor: 'text-amber-700',
    borderColor: 'border-amber-200',
    badgeBg: 'bg-amber-200',
    badgeText: 'text-amber-700',
    description: 'Fan comprometido. Saluda, comenta, pide canciones. Parte activa de la comunidad.',
    minHours: 200,
    minComments: 50,
    minParticipations: 15,
    benefits: ['Seguir 10 programas', 'Saludos al aire', 'Concursos exclusivos', '3 dispositivos'],
  },
  {
    id: 4,
    name: 'Top Fan',
    slug: 'top-fan',
    level: 4,
    icon: 'ri-user-star-line',
    color: 'orange',
    bgColor: 'bg-orange-50',
    textColor: 'text-orange-700',
    borderColor: 'border-orange-200',
    badgeBg: 'bg-orange-200',
    badgeText: 'text-orange-700',
    description: 'Top Fan reconocido. Aparece en rankings, tiene insignia visible en el chat.',
    minHours: 500,
    minComments: 200,
    minParticipations: 30,
    benefits: ['Insignia destacada en chat', 'Solicitudes prioritarias', 'Eventos exclusivos', '5 dispositivos'],
  },
  {
    id: 5,
    name: 'VIP',
    slug: 'vip',
    level: 5,
    icon: 'ri-vip-crown-line',
    color: 'rose',
    bgColor: 'bg-rose-50',
    textColor: 'text-rose-700',
    borderColor: 'border-rose-200',
    badgeBg: 'bg-rose-200',
    badgeText: 'text-rose-700',
    description: 'Oyente VIP con beneficios premium. Acceso anticipado a contenido y trato preferencial.',
    minHours: 1000,
    minComments: 500,
    minParticipations: 60,
    benefits: ['Acceso anticipado a eventos', 'Menciones al aire', 'Regalos RFW trimestrales', 'Soporte prioritario', 'Dispositivos ilimitados'],
  },
  {
    id: 6,
    name: 'Embajador RFW',
    slug: 'embajador-rfw',
    level: 6,
    icon: 'ri-shield-star-line',
    color: 'violet',
    bgColor: 'bg-violet-50',
    textColor: 'text-violet-700',
    borderColor: 'border-violet-200',
    badgeBg: 'bg-violet-200',
    badgeText: 'text-violet-700',
    description: 'El máximo nivel. Representa a RFW en su comunidad, tiene voz en decisiones de plataforma.',
    minHours: 2000,
    minComments: 1000,
    minParticipations: 120,
    benefits: ['Voz en consejo RFW', 'Contenido co-creado', 'Regalos mensuales', 'Badge dorado vitalicio', 'Acceso total ilimitado'],
  },
];

export const listenerProfiles: ListenerProfile[] = [
  {
    id: 1,
    name: 'Javier Mendoza',
    photoUrl: 'https://readdy.ai/api/search-image?query=Young%20latino%20man%20in%20his%20twenties%2C%20sporty%20look%2C%20energetic%20confident%20expression%2C%20clean%20portrait%2C%20natural%20lighting%2C%20editorial%20photography%20with%20simple%20warm%20background&width=200&height=200&seq=lp-javier-m&orientation=squarish',
    username: '@javiermendoza',
    tierId: 6,
    tierName: 'Embajador RFW',
    tierLevel: 6,
    hoursListened: 2456,
    comments: 1320,
    participations: 156,
    greetings: 284,
    requests: 82,
    joinedDate: '2022-03-15',
    mainRadio: 'Radio Deportiva Total',
    mainRadioFrequency: '95.7 FM',
    progressToNext: 100,
    nextTierName: 'Máximo Nivel',
  },
  {
    id: 2,
    name: 'Felipe Gutiérrez',
    photoUrl: 'https://readdy.ai/api/search-image?query=Young%20latino%20man%20in%20his%20twenties%2C%20charismatic%20expression%2C%20casual%20streetwear%20style%2C%20clean%20portrait%2C%20natural%20lighting%2C%20editorial%20photography%20with%20simple%20warm%20background&width=200&height=200&seq=lp-felipe-g&orientation=squarish',
    username: '@felipegutierrez',
    tierId: 6,
    tierName: 'Embajador RFW',
    tierLevel: 6,
    hoursListened: 2180,
    comments: 1156,
    participations: 138,
    greetings: 186,
    requests: 65,
    joinedDate: '2022-06-22',
    mainRadio: 'Estéreo Capital',
    mainRadioFrequency: '102.1 FM',
    progressToNext: 100,
    nextTierName: 'Máximo Nivel',
  },
  {
    id: 3,
    name: 'Isabella Torres',
    photoUrl: 'https://readdy.ai/api/search-image?query=Young%20latina%20woman%20in%20her%20twenties%2C%20stylish%20creative%20look%2C%20warm%20genuine%20expression%2C%20clean%20portrait%2C%20natural%20lighting%2C%20editorial%20photography%20with%20simple%20warm%20background&width=200&height=200&seq=lp-isabella-t&orientation=squarish',
    username: '@isabellatorres',
    tierId: 5,
    tierName: 'VIP',
    tierLevel: 5,
    hoursListened: 1650,
    comments: 785,
    participations: 94,
    greetings: 168,
    requests: 51,
    joinedDate: '2023-01-10',
    mainRadio: 'Radio Élite Digital',
    mainRadioFrequency: '99.1 FM',
    progressToNext: 72,
    nextTierName: 'Embajador RFW',
  },
  {
    id: 4,
    name: 'Adriana Mejía',
    photoUrl: 'https://readdy.ai/api/search-image?query=Young%20latina%20woman%20in%20her%20twenties%2C%20warm%20nostalgic%20style%2C%20gentle%20genuine%20smile%2C%20clean%20portrait%2C%20natural%20lighting%2C%20editorial%20photography%20with%20simple%20warm%20background&width=200&height=200&seq=lp-adriana-m&orientation=squarish',
    username: '@adrianamejia',
    tierId: 5,
    tierName: 'VIP',
    tierLevel: 5,
    hoursListened: 1420,
    comments: 648,
    participations: 78,
    greetings: 175,
    requests: 42,
    joinedDate: '2023-04-05',
    mainRadio: 'Radio Peninsular',
    mainRadioFrequency: '101.9 FM',
    progressToNext: 58,
    nextTierName: 'Embajador RFW',
  },
  {
    id: 5,
    name: 'Camila Restrepo',
    photoUrl: 'https://readdy.ai/api/search-image?query=Young%20latina%20woman%20in%20her%20twenties%2C%20warm%20friendly%20smile%2C%20casual%20urban%20style%2C%20clean%20soft%20portrait%2C%20natural%20lighting%2C%20editorial%20photography%20with%20simple%20warm%20background&width=200&height=200&seq=lp-camila-r&orientation=squarish',
    username: '@camilarestrepo',
    tierId: 4,
    tierName: 'Top Fan',
    tierLevel: 4,
    hoursListened: 820,
    comments: 385,
    participations: 48,
    greetings: 142,
    requests: 38,
    joinedDate: '2023-07-18',
    mainRadio: 'Radio Éxito FM',
    mainRadioFrequency: '98.5 FM',
    progressToNext: 64,
    nextTierName: 'VIP',
  },
  {
    id: 6,
    name: 'Gabriel Paredes',
    photoUrl: 'https://readdy.ai/api/search-image?query=Young%20latino%20man%20in%20his%20twenties%2C%20intellectual%20look%2C%20warm%20thoughtful%20expression%2C%20clean%20portrait%2C%20natural%20lighting%2C%20editorial%20photography%20with%20simple%20warm%20background&width=200&height=200&seq=lp-gabriel-p&orientation=squarish',
    username: '@gabrielparedes',
    tierId: 4,
    tierName: 'Top Fan',
    tierLevel: 4,
    hoursListened: 745,
    comments: 342,
    participations: 42,
    greetings: 145,
    requests: 31,
    joinedDate: '2023-09-02',
    mainRadio: 'Radio Industria',
    mainRadioFrequency: '93.5 FM',
    progressToNext: 52,
    nextTierName: 'VIP',
  },
  {
    id: 7,
    name: 'María José Salazar',
    photoUrl: 'https://readdy.ai/api/search-image?query=Young%20latina%20woman%20in%20her%20twenties%2C%20bright%20friendly%20smile%2C%20trendy%20casual%20look%2C%20clean%20portrait%2C%20natural%20lighting%2C%20editorial%20photography%20with%20simple%20warm%20background&width=200&height=200&seq=lp-mariajose-s&orientation=squarish',
    username: '@majosalazar',
    tierId: 4,
    tierName: 'Top Fan',
    tierLevel: 4,
    hoursListened: 688,
    comments: 298,
    participations: 38,
    greetings: 155,
    requests: 28,
    joinedDate: '2023-10-14',
    mainRadio: 'Estéreo Capital',
    mainRadioFrequency: '102.1 FM',
    progressToNext: 46,
    nextTierName: 'VIP',
  },
  {
    id: 8,
    name: 'Paola Rincón',
    photoUrl: 'https://readdy.ai/api/search-image?query=Young%20latina%20woman%20in%20her%20twenties%2C%20sporty%20casual%20style%2C%20confident%20warm%20smile%2C%20clean%20portrait%2C%20natural%20lighting%2C%20editorial%20photography%20with%20simple%20warm%20background&width=200&height=200&seq=lp-paola-r&orientation=squarish',
    username: '@paolarincon',
    tierId: 4,
    tierName: 'Top Fan',
    tierLevel: 4,
    hoursListened: 620,
    comments: 275,
    participations: 35,
    greetings: 132,
    requests: 24,
    joinedDate: '2023-11-20',
    mainRadio: 'Radio Deportiva Total',
    mainRadioFrequency: '95.7 FM',
    progressToNext: 38,
    nextTierName: 'VIP',
  },
  {
    id: 9,
    name: 'Andrés Murillo',
    photoUrl: 'https://readdy.ai/api/search-image?query=Young%20latino%20man%20in%20his%20twenties%2C%20confident%20smile%2C%20casual%20hoodie%2C%20clean%20portrait%2C%20natural%20lighting%2C%20editorial%20photography%20with%20simple%20warm%20background&width=200&height=200&seq=lp-andres-m&orientation=squarish',
    username: '@andresmurillo',
    tierId: 3,
    tierName: 'Fan',
    tierLevel: 3,
    hoursListened: 412,
    comments: 175,
    participations: 28,
    greetings: 98,
    requests: 20,
    joinedDate: '2024-01-08',
    mainRadio: 'Radio Éxito FM',
    mainRadioFrequency: '98.5 FM',
    progressToNext: 82,
    nextTierName: 'Top Fan',
  },
  {
    id: 10,
    name: 'Santiago López',
    photoUrl: 'https://readdy.ai/api/search-image?query=Young%20latino%20man%20in%20his%20twenties%2C%20tech%20casual%20style%2C%20friendly%20smile%2C%20clean%20portrait%2C%20natural%20lighting%2C%20editorial%20photography%20with%20simple%20warm%20background&width=200&height=200&seq=lp-santiago-l&orientation=squarish',
    username: '@santilopez',
    tierId: 3,
    tierName: 'Fan',
    tierLevel: 3,
    hoursListened: 395,
    comments: 162,
    participations: 26,
    greetings: 112,
    requests: 18,
    joinedDate: '2024-02-15',
    mainRadio: 'Radio Élite Digital',
    mainRadioFrequency: '99.1 FM',
    progressToNext: 76,
    nextTierName: 'Top Fan',
  },
  {
    id: 11,
    name: 'Natalia Córdoba',
    photoUrl: 'https://readdy.ai/api/search-image?query=Young%20latina%20woman%20in%20her%20twenties%2C%20professional%20elegant%20style%2C%20warm%20confident%20smile%2C%20clean%20portrait%2C%20natural%20lighting%2C%20editorial%20photography%20with%20simple%20warm%20background&width=200&height=200&seq=lp-natalia-c&orientation=squarish',
    username: '@nataliacordoba',
    tierId: 3,
    tierName: 'Fan',
    tierLevel: 3,
    hoursListened: 378,
    comments: 148,
    participations: 24,
    greetings: 108,
    requests: 16,
    joinedDate: '2024-03-22',
    mainRadio: 'Radio Industria',
    mainRadioFrequency: '93.5 FM',
    progressToNext: 70,
    nextTierName: 'Top Fan',
  },
  {
    id: 12,
    name: 'Laura Santamaría',
    photoUrl: 'https://readdy.ai/api/search-image?query=Young%20latina%20woman%20in%20her%20twenties%2C%20genuine%20warm%20smile%2C%20casual%20elegant%20style%2C%20clean%20portrait%2C%20natural%20lighting%2C%20editorial%20photography%20with%20simple%20warm%20background&width=200&height=200&seq=lp-laura-s&orientation=squarish',
    username: '@laurasantamaria',
    tierId: 3,
    tierName: 'Fan',
    tierLevel: 3,
    hoursListened: 355,
    comments: 135,
    participations: 22,
    greetings: 76,
    requests: 14,
    joinedDate: '2024-04-10',
    mainRadio: 'Radio Éxito FM',
    mainRadioFrequency: '98.5 FM',
    progressToNext: 66,
    nextTierName: 'Top Fan',
  },
  {
    id: 13,
    name: 'Daniel Ortega',
    photoUrl: 'https://readdy.ai/api/search-image?query=Young%20latino%20man%20in%20his%20twenties%2C%20relaxed%20smile%2C%20casual%20t-shirt%2C%20clean%20portrait%2C%20natural%20lighting%2C%20editorial%20photography%20with%20simple%20warm%20background&width=200&height=200&seq=lp-daniel-o&orientation=squarish',
    username: '@danielortega',
    tierId: 3,
    tierName: 'Fan',
    tierLevel: 3,
    hoursListened: 340,
    comments: 128,
    participations: 20,
    greetings: 88,
    requests: 13,
    joinedDate: '2024-04-28',
    mainRadio: 'Estéreo Capital',
    mainRadioFrequency: '102.1 FM',
    progressToNext: 60,
    nextTierName: 'Top Fan',
  },
  {
    id: 14,
    name: 'Carlos Herrera',
    photoUrl: 'https://readdy.ai/api/search-image?query=Young%20latino%20man%20in%20his%20twenties%2C%20friendly%20casual%20smile%2C%20simple%20t-shirt%2C%20clean%20portrait%2C%20natural%20lighting%2C%20editorial%20photography%20with%20simple%20warm%20background&width=200&height=200&seq=lp-carlos-h&orientation=squarish',
    username: '@carlosherrera',
    tierId: 3,
    tierName: 'Fan',
    tierLevel: 3,
    hoursListened: 325,
    comments: 118,
    participations: 19,
    greetings: 95,
    requests: 12,
    joinedDate: '2024-05-14',
    mainRadio: 'Radio Deportiva Total',
    mainRadioFrequency: '95.7 FM',
    progressToNext: 54,
    nextTierName: 'Top Fan',
  },
  {
    id: 15,
    name: 'Roberto Silva',
    photoUrl: 'https://readdy.ai/api/search-image?query=Young%20latino%20man%20in%20his%20twenties%2C%20warm%20classic%20style%2C%20friendly%20genuine%20smile%2C%20clean%20portrait%2C%20natural%20lighting%2C%20editorial%20photography%20with%20simple%20warm%20background&width=200&height=200&seq=lp-roberto-s&orientation=squarish',
    username: '@robertosilva',
    tierId: 2,
    tierName: 'Activo',
    tierLevel: 2,
    hoursListened: 185,
    comments: 68,
    participations: 12,
    greetings: 48,
    requests: 8,
    joinedDate: '2024-07-05',
    mainRadio: 'Radio Peninsular',
    mainRadioFrequency: '101.9 FM',
    progressToNext: 78,
    nextTierName: 'Fan',
  },
  {
    id: 16,
    name: 'Valeria Duque',
    photoUrl: 'https://readdy.ai/api/search-image?query=Young%20latina%20woman%20in%20her%20twenties%2C%20creative%20artsy%20style%2C%20warm%20open%20smile%2C%20clean%20portrait%2C%20natural%20lighting%2C%20editorial%20photography%20with%20simple%20warm%20background&width=200&height=200&seq=lp-valeria-d&orientation=squarish',
    username: '@valeriaduque',
    tierId: 2,
    tierName: 'Activo',
    tierLevel: 2,
    hoursListened: 162,
    comments: 58,
    participations: 11,
    greetings: 42,
    requests: 7,
    joinedDate: '2024-08-12',
    mainRadio: 'Radio Élite Digital',
    mainRadioFrequency: '99.1 FM',
    progressToNext: 64,
    nextTierName: 'Fan',
  },
  {
    id: 17,
    name: 'Mateo Álvarez',
    photoUrl: 'https://readdy.ai/api/search-image?query=Young%20latino%20man%20in%20his%20twenties%2C%20serious%20engaged%20expression%2C%20casual%20neat%20style%2C%20clean%20portrait%2C%20natural%20lighting%2C%20editorial%20photography%20with%20simple%20warm%20background&width=200&height=200&seq=lp-mateo-a&orientation=squarish',
    username: '@mateoalvarez',
    tierId: 2,
    tierName: 'Activo',
    tierLevel: 2,
    hoursListened: 148,
    comments: 52,
    participations: 10,
    greetings: 38,
    requests: 6,
    joinedDate: '2024-09-03',
    mainRadio: 'Radio Industria',
    mainRadioFrequency: '93.5 FM',
    progressToNext: 56,
    nextTierName: 'Fan',
  },
  {
    id: 18,
    name: 'Carmen Díaz',
    photoUrl: 'https://readdy.ai/api/search-image?query=Young%20latina%20woman%20in%20her%20twenties%2C%20vintage%20chic%20style%2C%20warm%20expressive%20smile%2C%20clean%20portrait%2C%20natural%20lighting%2C%20editorial%20photography%20with%20simple%20warm%20background&width=200&height=200&seq=lp-carmen-d&orientation=squarish',
    username: '@carmendiaz',
    tierId: 2,
    tierName: 'Activo',
    tierLevel: 2,
    hoursListened: 132,
    comments: 45,
    participations: 9,
    greetings: 35,
    requests: 5,
    joinedDate: '2024-09-20',
    mainRadio: 'Radio Peninsular',
    mainRadioFrequency: '101.9 FM',
    progressToNext: 48,
    nextTierName: 'Fan',
  },
  {
    id: 19,
    name: 'Diego Ramírez',
    photoUrl: 'https://readdy.ai/api/search-image?query=Young%20latino%20man%20in%20his%20twenties%2C%20casual%20relaxed%20look%2C%20warm%20natural%20smile%2C%20clean%20portrait%2C%20natural%20lighting%2C%20editorial%20photography%20with%20simple%20warm%20background&width=200&height=200&seq=lp-diego-r&orientation=squarish',
    username: '@diegoramirez',
    tierId: 2,
    tierName: 'Activo',
    tierLevel: 2,
    hoursListened: 115,
    comments: 38,
    participations: 8,
    greetings: 28,
    requests: 4,
    joinedDate: '2024-10-08',
    mainRadio: 'Estéreo Capital',
    mainRadioFrequency: '102.1 FM',
    progressToNext: 42,
    nextTierName: 'Fan',
  },
  {
    id: 20,
    name: 'Ana Lucía Vargas',
    photoUrl: 'https://readdy.ai/api/search-image?query=Young%20latina%20woman%20in%20her%20twenties%2C%20fresh%20natural%20beauty%2C%20casual%20boho%20style%2C%20warm%20smile%2C%20clean%20portrait%2C%20natural%20lighting%2C%20editorial%20photography%20with%20simple%20warm%20background&width=200&height=200&seq=lp-ana-lucia&orientation=squarish',
    username: '@analuvargas',
    tierId: 2,
    tierName: 'Activo',
    tierLevel: 2,
    hoursListened: 98,
    comments: 32,
    participations: 7,
    greetings: 24,
    requests: 3,
    joinedDate: '2024-11-15',
    mainRadio: 'Radio Éxito FM',
    mainRadioFrequency: '98.5 FM',
    progressToNext: 35,
    nextTierName: 'Fan',
  },
  {
    id: 21,
    name: 'Tomás Navarro',
    photoUrl: 'https://readdy.ai/api/search-image?query=Young%20latino%20man%20in%20his%20twenties%2C%20curious%20enthusiastic%20look%2C%20casual%20hoodie%20style%2C%20clean%20portrait%2C%20natural%20lighting%2C%20editorial%20photography%20with%20simple%20warm%20background&width=200&height=200&seq=lp-tomas-n&orientation=squarish',
    username: '@tomasnavarro',
    tierId: 2,
    tierName: 'Activo',
    tierLevel: 2,
    hoursListened: 82,
    comments: 26,
    participations: 6,
    greetings: 18,
    requests: 3,
    joinedDate: '2024-12-02',
    mainRadio: 'Radio Deportiva Total',
    mainRadioFrequency: '95.7 FM',
    progressToNext: 28,
    nextTierName: 'Fan',
  },
  {
    id: 22,
    name: 'Lucía Mendoza',
    photoUrl: 'https://readdy.ai/api/search-image?query=Young%20latina%20woman%20in%20her%20twenties%2C%20fresh%20natural%20look%2C%20warm%20friendly%20eyes%2C%20clean%20portrait%2C%20natural%20lighting%2C%20editorial%20photography%20with%20simple%20warm%20background&width=200&height=200&seq=lp-lucia-m&orientation=squarish',
    username: '@luciamendoza',
    tierId: 1,
    tierName: 'Nuevo',
    tierLevel: 1,
    hoursListened: 38,
    comments: 8,
    participations: 4,
    greetings: 5,
    requests: 2,
    joinedDate: '2025-01-15',
    mainRadio: 'Radio Éxito FM',
    mainRadioFrequency: '98.5 FM',
    progressToNext: 65,
    nextTierName: 'Activo',
  },
  {
    id: 23,
    name: 'Pedro Castillo',
    photoUrl: 'https://readdy.ai/api/search-image?query=Young%20latino%20man%20in%20his%20twenties%2C%20friendly%20approachable%20look%2C%20casual%20polo%20style%2C%20clean%20portrait%2C%20natural%20lighting%2C%20editorial%20photography%20with%20simple%20warm%20background&width=200&height=200&seq=lp-pedro-c&orientation=squarish',
    username: '@pedrocastillo',
    tierId: 1,
    tierName: 'Nuevo',
    tierLevel: 1,
    hoursListened: 32,
    comments: 7,
    participations: 3,
    greetings: 4,
    requests: 1,
    joinedDate: '2025-02-08',
    mainRadio: 'Estéreo Capital',
    mainRadioFrequency: '102.1 FM',
    progressToNext: 55,
    nextTierName: 'Activo',
  },
  {
    id: 24,
    name: 'Mariana Gil',
    photoUrl: 'https://readdy.ai/api/search-image?query=Young%20latina%20woman%20in%20her%20twenties%2C%20sweet%20genuine%20smile%2C%20casual%20feminine%20style%2C%20clean%20portrait%2C%20natural%20lighting%2C%20editorial%20photography%20with%20simple%20warm%20background&width=200&height=200&seq=lp-mariana-g&orientation=squarish',
    username: '@marianagil',
    tierId: 1,
    tierName: 'Nuevo',
    tierLevel: 1,
    hoursListened: 25,
    comments: 5,
    participations: 2,
    greetings: 3,
    requests: 1,
    joinedDate: '2025-03-01',
    mainRadio: 'Radio Peninsular',
    mainRadioFrequency: '101.9 FM',
    progressToNext: 42,
    nextTierName: 'Activo',
  },
  {
    id: 25,
    name: 'Julián Restrepo',
    photoUrl: 'https://readdy.ai/api/search-image?query=Young%20latino%20man%20in%20his%20twenties%2C%20relaxed%20easygoing%20smile%2C%20casual%20denim%20style%2C%20clean%20portrait%2C%20natural%20lighting%2C%20editorial%20photography%20with%20simple%20warm%20background&width=200&height=200&seq=lp-julian-r&orientation=squarish',
    username: '@julianrestrepo',
    tierId: 1,
    tierName: 'Nuevo',
    tierLevel: 1,
    hoursListened: 18,
    comments: 4,
    participations: 2,
    greetings: 2,
    requests: 1,
    joinedDate: '2025-03-20',
    mainRadio: 'Radio Industria',
    mainRadioFrequency: '93.5 FM',
    progressToNext: 32,
    nextTierName: 'Activo',
  },
  {
    id: 26,
    name: 'Sofía Montoya',
    photoUrl: 'https://readdy.ai/api/search-image?query=Young%20latina%20woman%20in%20her%20twenties%2C%20bright%20curious%20expression%2C%20casual%20chic%20style%2C%20clean%20portrait%2C%20natural%20lighting%2C%20editorial%20photography%20with%20simple%20warm%20background&width=200&height=200&seq=lp-sofia-m&orientation=squarish',
    username: '@sofiamontoya',
    tierId: 1,
    tierName: 'Nuevo',
    tierLevel: 1,
    hoursListened: 12,
    comments: 3,
    participations: 1,
    greetings: 1,
    requests: 0,
    joinedDate: '2025-04-10',
    mainRadio: 'Radio Élite Digital',
    mainRadioFrequency: '99.1 FM',
    progressToNext: 22,
    nextTierName: 'Activo',
  },
  {
    id: 27,
    name: 'Emilio Castro',
    photoUrl: 'https://readdy.ai/api/search-image?query=Young%20latino%20man%20in%20his%20twenties%2C%20energetic%20sporty%20look%2C%20fresh%20smile%2C%20clean%20portrait%2C%20natural%20lighting%2C%20editorial%20photography%20with%20simple%20warm%20background&width=200&height=200&seq=lp-emilio-c&orientation=squarish',
    username: '@emiliocastro',
    tierId: 1,
    tierName: 'Nuevo',
    tierLevel: 1,
    hoursListened: 8,
    comments: 2,
    participations: 1,
    greetings: 1,
    requests: 0,
    joinedDate: '2025-05-02',
    mainRadio: 'Radio Deportiva Total',
    mainRadioFrequency: '95.7 FM',
    progressToNext: 15,
    nextTierName: 'Activo',
  },
  {
    id: 28,
    name: 'Renata Suárez',
    photoUrl: 'https://readdy.ai/api/search-image?query=Young%20latina%20woman%20in%20her%20twenties%2C%20elegant%20warm%20smile%2C%20sophisticated%20casual%20look%2C%20clean%20portrait%2C%20natural%20lighting%2C%20editorial%20photography%20with%20simple%20warm%20background&width=200&height=200&seq=lp-renata-s&orientation=squarish',
    username: '@renatasuarez',
    tierId: 1,
    tierName: 'Nuevo',
    tierLevel: 1,
    hoursListened: 5,
    comments: 1,
    participations: 0,
    greetings: 0,
    requests: 0,
    joinedDate: '2025-05-20',
    mainRadio: 'Radio Éxito FM',
    mainRadioFrequency: '98.5 FM',
    progressToNext: 10,
    nextTierName: 'Activo',
  },
  {
    id: 29,
    name: 'Lucas Fernández',
    photoUrl: 'https://readdy.ai/api/search-image?query=Young%20latino%20man%20in%20his%20twenties%2C%20cool%20relaxed%20vibe%2C%20urban%20casual%20style%2C%20clean%20portrait%2C%20natural%20lighting%2C%20editorial%20photography%20with%20simple%20warm%20background&width=200&height=200&seq=lp-lucas-f&orientation=squarish',
    username: '@lucasfernandez',
    tierId: 1,
    tierName: 'Nuevo',
    tierLevel: 1,
    hoursListened: 3,
    comments: 0,
    participations: 0,
    greetings: 0,
    requests: 0,
    joinedDate: '2025-06-05',
    mainRadio: 'Estéreo Capital',
    mainRadioFrequency: '102.1 FM',
    progressToNext: 6,
    nextTierName: 'Activo',
  },
  {
    id: 30,
    name: 'Valentina Ochoa',
    photoUrl: 'https://readdy.ai/api/search-image?query=Young%20latina%20woman%20in%20her%20twenties%2C%20fresh%20glowing%20smile%2C%20casual%20trendy%20style%2C%20clean%20portrait%2C%20natural%20lighting%2C%20editorial%20photography%20with%20simple%20warm%20background&width=200&height=200&seq=lp-valentina-o&orientation=squarish',
    username: '@valentinaochoa',
    tierId: 1,
    tierName: 'Nuevo',
    tierLevel: 1,
    hoursListened: 1,
    comments: 0,
    participations: 0,
    greetings: 0,
    requests: 0,
    joinedDate: '2025-06-15',
    mainRadio: 'Radio Peninsular',
    mainRadioFrequency: '101.9 FM',
    progressToNext: 2,
    nextTierName: 'Activo',
  },
];

export const tierDistribution = {
  nuevo: 9,
  activo: 7,
  fan: 6,
  topFan: 4,
  vip: 2,
  embajadorRfw: 2,
};

export const tierColorMap: Record<string, { bg: string; text: string; border: string; dot: string }> = {
  'Nuevo': { bg: 'bg-stone-50', text: 'text-stone-600', border: 'border-stone-200', dot: 'bg-stone-400' },
  'Activo': { bg: 'bg-emerald-50', text: 'text-emerald-600', border: 'border-emerald-200', dot: 'bg-emerald-400' },
  'Fan': { bg: 'bg-amber-50', text: 'text-amber-600', border: 'border-amber-200', dot: 'bg-amber-400' },
  'Top Fan': { bg: 'bg-orange-50', text: 'text-orange-600', border: 'border-orange-200', dot: 'bg-orange-400' },
  'VIP': { bg: 'bg-rose-50', text: 'text-rose-600', border: 'border-rose-200', dot: 'bg-rose-400' },
  'Embajador RFW': { bg: 'bg-violet-50', text: 'text-violet-600', border: 'border-violet-200', dot: 'bg-violet-400' },
};